import { BffBrandType } from '@/types/generated';

import { TagThemeType } from '@shared-components/types';
import { officePathByBrand } from '@utils/officeURLByBrand';

type ScheduleButtonLocation = {
	// Legacy Facility adapters carry brand as a plain string.
	brand?: string;
	code?: string | null;
	scheduling?: {
		schedulingUrl?: string | null;
	} | null;
};

type OfficeDetailsLocationAddress = {
	stateCode?: string | null;
	city?: string | null;
	address1?: string | null;
	zipCode?: string | null;
};

export const getFacilityDetailsUrl = (facilityBasePath: string | undefined, facilityURL: string) => {
	// need the whole url to reload the page till ODP pages are migrated
	return facilityBasePath
		? `${globalThis.location?.origin}/${facilityBasePath}/${facilityURL}/`
		: `${globalThis.location?.origin}/${facilityURL}/`;
};

export const getScheduleButtonUrl = ({
	location,
}: {
	schedulingPathFromConfig: string;
	facilityBrand: BffBrandType;
	location: ScheduleButtonLocation;
}): string => {
	const baseUrl = location?.scheduling?.schedulingUrl ?? '#';
	if (baseUrl.includes('fc')) {
		return baseUrl;
	}
	const separator = baseUrl.includes('?') ? '&fc=' : '?fc=';
	return `${baseUrl}${separator}${location?.code}`;
};

export const getOfficeDetailsUrl = ({
	facilityBasePath,
	themeId,
	locationAddress,
}: {
	facilityBasePath?: string;
	themeId: TagThemeType;
	locationAddress?: OfficeDetailsLocationAddress | null;
}): string => {
	const { stateCode: state, city, address1, zipCode } = locationAddress ?? {};
	const basePath = facilityBasePath ? `/${facilityBasePath}` : '';
	return `${basePath}/${officePathByBrand(themeId, {
		stateStrOptions: {
			stateAbbreviation: state ?? '',
			state: '',
			city: city ?? '',
		},
		cityAddressOptions: {
			city: city ?? undefined,
			address: address1?.replaceAll('/', '-') ?? undefined,
			zip: zipCode ?? undefined,
		},
	})}/`;
};
export enum RequestStatus {
	NotAsked = 'NOTASKED',
	Loading = 'LOADING',
	Success = 'SUCCESS',
	Failure = 'FAILURE',
}
